<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div
    class="{{!isDisabled ? 'agpr-datePicker' : 'agpr-datePicker--disabled'}} agpr-contextMenu-parent"
    [ngClass]="{
        'agpr-datePicker--disabled': isDisabled,
        'agpr-datePicker--showingPreview': !editable && calendarDate
    }"
>
    <ul role="group" aria-label="Date Block" [attr.aria-describedby]="errorsId">
        @if (showMoveButtons && !isDisabled && !editable) {
            <ul
                class="agpr-contextMenu top left"
                [ngClass]="{'agpr-datePicker-iconBlock--mod':editable}"
                role="menu"
                aria-label="Move Block"
            >
                <li role="menuitem">
                    <agpr-button
                        [disabled]="moveUpDisabled"
                        icon="fa-regular fa-arrow-up"
                        class="agpr-datePicker-moveUp"
                        (click)="onMoveUp()"
                        [tooltip]="'PageBuilder.briefings.blockIcon.moveUp'"
                        [style]="buttonTypes.contextMenu"
                    >
                    </agpr-button>
                </li>
                <li role="menuitem">
                    <agpr-button
                        [disabled]="moveDownDisabled"
                        icon="fa-regular fa-arrow-down"
                        class="agpr-datePicker-moveDown"
                        (click)="onMoveDown()"
                        [tooltip]="'PageBuilder.briefings.blockIcon.moveDown'"
                        [style]="buttonTypes.contextMenu"
                    >
                    </agpr-button>
                </li>
            </ul>
        }
        @if (!isDisabled && !editable) {
            <ul
                class="agpr-contextMenu top right"
                aria-label="Edit Block"
                role="menu"
            >
                @if (showDelete) {
                    <li role="menuitem">
                        <agpr-button
                            class="agpr-datePicker-delete"
                            icon="fa-regular fa-duotone fa-trash-can"
                            (click)="onDelete($event)"
                            [tooltip]="'PageBuilder.briefings.blockIcon.delete'"
                            [style]="buttonTypes.contextMenu"
                        ></agpr-button>
                    </li>
                }
                <li role="menuitem">
                    <agpr-button
                        class="agpr-datePicker-edit"
                        icon="fa-regular fa-duotone fa-pen"
                        (click)="onEdit($event)"
                        [tooltip]="'PageBuilder.briefings.blockIcon.edit'"
                        [style]="buttonTypes.contextMenu"
                    ></agpr-button>
                </li>
            </ul>
        }
    </ul>


    @if (editable) {
        <div class="agpr-datePicker-date">
            <label id="datePicker-label">
                <span class="u-srOnly">Type or select a date. Date Format: Month, Day, Year</span>
            </label>
            <agpr-date-picker
                #calendar
                [placeholder]="placeholder"
                [disabled]="isDisabled"
                [dateFormat]="calendarDateFormat"
                [defaultDate]="calendarDate"
                [(ngModel)]="calendarDate"
                (close)="onCalendarClose()"
                (select)="onCalendarSelect($event)"
                [ariaLabelledBy]="'datePicker-label'"
            ></agpr-date-picker>
        </div>
    } @else if (calendarDate) {
        <div
            class="agpr-datePicker-preview"
            [innerHTML]="getFormattedDate(calendarDate, previewDateFormat)"
            (click)="onEdit($event)"
        >
        </div>
    } @else {
        <div
            class="agpr-datePicker-placeholder"
            (click)="onEdit($event)"
        >
            <span class="agpr-datePicker-placeholderIcon" [ngClass]="placeholderIcon"></span>
            <span class="agpr-datePicker-placeholderText">{{placeholder}}</span>
        </div>
    }
</div>
